/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import { bool } from 'prop-types';
import { Placeholder, Row, Col } from '@thd-olt-component-react/core-ui';
import { ArticleTilePlaceholder } from './ArticleTileHeader/ArticleTilePlaceholder';

const ProjectShoppingPlaceholder = ({ isEntryPoint }) => {
  return (
    <Row>
      <Col>
        {!isEntryPoint ? new Array(4).fill('').map((value, key) => (
          <Placeholder
            key={`text-${key}`}
            type="text"
            className="sui-max-w-[500px]"
            height="14px"
          />
        )) : <ArticleTilePlaceholder />}
      </Col>
      <Col>
        {new Array(2).fill('').map((value, key) => (
          <Placeholder
            key={`text-${key}`}
            type="text"
            className="sui-max-w-[500px] sui-my-[10px] sui-mx-0"
            height="400px"
          />
        ))}
      </Col>
    </Row>
  );
};

ProjectShoppingPlaceholder.propTypes = {
  isEntryPoint: bool
};
ProjectShoppingPlaceholder.defaultProps = {
  isEntryPoint: false
};

export { ProjectShoppingPlaceholder };
